import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ReservaPage = lazy(() => import('../pages/reserva/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/reserva',
    element: <ReservaPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
